export enum ValidationTypeOTP {
	PHONE = "PHONE",
	EMAIL = "EMAIL",
	PASSWORD_RESET = "PASSWORD_RESET",
}
